export default "__VITE_ASSET__3e0f304e__"